<p-dialog [(visible)]="showModal" [style]="{width: '75vw'}" [modal]="true" [showHeader]="false" [closable]="false"
  appendTo="body">
  <div style="position:relative; top: 8px; right: 8px;">
    <div style="position: relative; float: right" class="link-button">
      <a class="muted7" (click)="close()"><img src="./assets/images/close.svg" class="filter-invert" /></a>
    </div>
  </div>
  <div style="padding: 16px;" *ngIf="model != null">
    <div>
      <div class="medium medium-text">User Details ({{model.roleName}})</div>
      <div *ngIf="showHeader" style="border-bottom: 1px solid #B4B4B4; padding-top:10px; margin-bottom: 10px;"></div>
    </div>

    <div class="row">
      <div class="col-6">
        <ng-container [ngSwitch]="model.roleId">
          <div *ngSwitchCase="UserRole.Customer">
            <table class="detail-table">
              <th id="user-detail-Customer" class="th-display-none"></th>
              <tbody>
                <tr>
                  <td>{{metadata['customerRoleName']}}</td>
                  <td>
                    <dynamic-value [type]="'text'" [value]="model.roleName"></dynamic-value>
                  </td>
                </tr>
                <tr>
                  <td>{{metadata['customerBusinessName']}}</td>
                  <td>
                    <dynamic-value [type]="'text'" [value]="model?.businessName"></dynamic-value>
                  </td>
                </tr>
                <tr>
                  <td>{{metadata['customerBusinessHours']}}</td>
                  <td>
                    <dynamic-value [type]="'text'" [value]="model.businessHours"></dynamic-value>
                  </td>
                </tr>
                <tr>
                  <td>{{metadata['customerEmail']}}</td>
                  <td>
                    <dynamic-value [type]="'text'" [value]="model.email"></dynamic-value>
                  </td>
                </tr>
                <tr>
                  <td>{{metadata['customerPhone']}}</td>
                  <td>
                    <dynamic-value [type]="'phone'" [value]="model.phone"></dynamic-value>
                  </td>
                </tr>
                <tr>
                  <td>{{metadata['customerAddress1']}}</td>
                  <td>
                    <dynamic-value [type]="'text'" [value]="model.address1" display="block"></dynamic-value>
                    <dynamic-value [type]="'text'" [value]="model.city"></dynamic-value>, <dynamic-value [type]="'text'"
                      [value]="model.stateCode"></dynamic-value>&nbsp;<dynamic-value [type]="'zip'" [value]="model.zip">
                    </dynamic-value>
                  </td>
                </tr>
                <tr>
                  <td>{{metadata['customerEnableNotifications']}}</td>
                  <td>
                    <dynamic-value [type]="'lookup'" [value]="model.enableNotifications" [items]="lookups['yesNoNull']">
                    </dynamic-value>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div *ngSwitchCase="UserRole.Carrier">
            <table class="detail-table">
              <th id="user-detail-carrier" class="th-display-none"></th>
              <tbody>
                <!-- <tr>
                  <td>{{metadata['carrierRoleName']}}</td>
                  <td>
                    <dynamic-value [type]="'text'" [value]="model.roleName"></dynamic-value>
                  </td>
                </tr> -->
                <tr>
                  <td>{{metadata['carrierBusinessName']}}</td>
                  <td>
                    <dynamic-value [type]="'text'" [value]="model.businessName"></dynamic-value>
                  </td>
                </tr>
                <tr>
                  <td>{{metadata['carrierAddress1']}}</td>
                  <td>
                    <dynamic-value [type]="'text'" [value]="model.address1" display="block"></dynamic-value>
                    <dynamic-value [type]="'text'" [value]="model.address2" display="block"></dynamic-value>
                    <dynamic-value [type]="'text'" [value]="model.city"></dynamic-value>, <dynamic-value [type]="'text'"
                      [value]="model.stateCode"></dynamic-value>&nbsp;<dynamic-value [type]="'zip'" [value]="model.zip">
                    </dynamic-value>
                  </td>
                </tr>
                <tr>
                  <td>{{metadata['carrierBusinessPhone']}}</td>
                  <td>
                    <dynamic-value [type]="'phone'" [value]="model.businessPhone"></dynamic-value>
                  </td>
                </tr>
                <tr>
                  <td>{{metadata['carrierPhone']}}</td>
                  <td>
                    <dynamic-value [type]="'phone'" [value]="model.phone"></dynamic-value>
                  </td>
                </tr>
                <tr>
                  <td>Additional Phones:</td>
                  <td>
                    <div *ngFor="let p of phones">
                      <dynamic-value [type]="'phone'" [value]="p"></dynamic-value>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>{{metadata['carrierEmail']}}</td>
                  <td>
                    <dynamic-value [type]="'text'" [value]="model.email"></dynamic-value>
                  </td>
                </tr>
                <tr>
                  <td>{{metadata['carrierFirstName']}}</td>
                  <td>
                    <dynamic-value [type]="'text'" [value]="model.firstName"></dynamic-value>&nbsp;<dynamic-value
                      [type]="'text'" [value]="model.lastName"></dynamic-value>
                  </td>
                </tr>
                <tr>
                  <td>{{metadata['carrierAchOnFile']}}</td>
                  <td>
                    <dynamic-value [type]="'lookup'" [value]="model.achOnFile" [items]="lookups['yesNoNull']">
                    </dynamic-value>
                  </td>
                </tr>
                <tr>
                  <td>{{metadata['carrierAchNumber']}}</td>
                  <td>
                    <dynamic-value [type]="'number'" [value]="model.achNumber"></dynamic-value>
                  </td>
                </tr>
                <tr>
                  <td>{{metadata['achAccountName']}}</td>
                  <td>
                    <dynamic-value [type]="'text'" [value]="model.achAccountName"></dynamic-value>
                  </td>
                </tr>
                <tr>
                  <td>{{metadata['carrierEnclosedAvailable']}}</td>
                  <td>
                    <dynamic-value [type]="'lookup'" [value]="model.enclosedAvailable" [items]="lookups['yesNoNull']">
                    </dynamic-value>
                  </td>
                </tr>
                <tr>
                  <td>{{metadata['carrierHasWinch']}}</td>
                  <td>
                    <dynamic-value [type]="'lookup'" [value]="model.hasWinch" [items]="lookups['yesNoNull']">
                    </dynamic-value>
                  </td>
                </tr>
                <tr>
                  <td>{{metadata['carrierMcDotNumber']}}</td>
                  <td>
                    <dynamic-value [type]="'text'" [value]="model.mcDotNumber"></dynamic-value>
                  </td>
                </tr>
                <tr *ngFor="let c of cargoLimit;let i = index;">
                  <td>{{metadata['carrierCargoInsuranceLimit']}} {{i + 1}}</td>
                  <td>
                    <div>
                      <dynamic-value [type]="'currency'" [value]="c"></dynamic-value>
                    </div>
                  </td>
                </tr>
                <tr *ngFor="let c of cargoInsurance;let i = index;">
                  <td>{{metadata['carrierCargoInsuranceDeductible']}} {{i + 1}}</td>
                  <td>
                    <div>
                      <dynamic-value [type]="'currency'" [value]="c"></dynamic-value>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>{{metadata['carrierTaxIdVerified']}}</td>
                  <td>
                    <dynamic-value [type]="'lookup'" [value]="model.taxIdVerified" [items]="lookups['yesNoNaNull']">
                    </dynamic-value>
                  </td>
                </tr>
                <tr>
                  <td>{{metadata['carrierTaxId']}}</td>
                  <td>
                    <dynamic-value [type]="'text'" [value]="model.taxId"></dynamic-value>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div *ngSwitchCase="UserRole.Agent">
            <table class="detail-table">
              <th id="user-detail-agent" class="th-display-none"></th>
              <tbody>
                <tr>
                  <td>{{metadata['agentRoleName']}}</td>
                  <td>
                    <dynamic-value [type]="'text'" [value]="model.roleName"></dynamic-value>
                  </td>
                </tr>
                <tr>
                  <td>{{metadata['agentFirstName']}}</td>
                  <td>
                    <dynamic-value [type]="'text'" [value]="model.firstName"></dynamic-value>&nbsp;<dynamic-value
                      [type]="'text'" [value]="model.lastName"></dynamic-value>
                  </td>
                </tr>
                <tr *ngIf="isAdmin">
                  <td>{{metadata['agentCommissionPercentage']}}</td>
                  <td>
                    <dynamic-value [type]="'number'" [value]="model.commissionPercentage"></dynamic-value>
                  </td>
                </tr>
                <tr>
                  <td>{{metadata['agentAddress1']}}</td>
                  <td>
                    <dynamic-value [type]="'text'" [value]="model.address1" display="block"></dynamic-value>
                    <dynamic-value [type]="'text'" [value]="model.address2" display="block"></dynamic-value>
                    <dynamic-value [type]="'text'" [value]="model.city"></dynamic-value>, <dynamic-value [type]="'text'"
                      [value]="model.stateCode"></dynamic-value>&nbsp;<dynamic-value [type]="'zip'" [value]="model.zip">
                    </dynamic-value>
                  </td>
                </tr>
                <tr>
                  <td>{{metadata['agentPhone']}}</td>
                  <td>
                    <dynamic-value [type]="'phone'" [value]="model.phone"></dynamic-value>
                  </td>
                </tr>
                <tr>
                  <td>{{metadata['agentEmail']}}</td>
                  <td>
                    <dynamic-value [type]="'text'" [value]="model.email"></dynamic-value>
                  </td>
                </tr>
                <tr>
                  <td>{{metadata['agentIsAdmin']}}</td>
                  <td>
                    <dynamic-value [type]="'lookup'" [value]="model.isAdmin" [items]="lookups['yesNoNull']">
                    </dynamic-value>
                  </td>
                </tr>
                <tr>
                  <td>{{metadata['agentAllowLogin']}}</td>
                  <td>
                    <dynamic-value [type]="'lookup'" [value]="model.allowLogin" [items]="lookups['yesNoNull']">
                    </dynamic-value>
                  </td>
                </tr>
                <tr>
                  <td>{{metadata['userName']}}</td>
                  <td><dynamic-value [type]="'text'" [value]="model.userName"></dynamic-value></td>
                </tr>
              </tbody>
            </table>
          </div>
        </ng-container>
      </div>
      <div class="col-6">
        <notes-detail [entityName]="'user'" [entityId]="model.id" [showAdd]="showNotesAdd"></notes-detail>

        <ng-container [ngSwitch]="model.roleId">
          <div *ngSwitchCase="UserRole.Customer">
            <contacts-detail [model]="model.contacts" [verbose]="true"></contacts-detail>
          </div>
          <div *ngSwitchCase="UserRole.Carrier">
            <ng-container *ngIf="model?.stats">
              <div class="medium medium-text">Carrier Statistics</div>
              <div style="border-bottom: 1px solid #B4B4B4; padding-top:10px; margin-bottom: 10px;"></div>
              <table class="detail-table">
                <th id="user-detail-stats" class="th-display-none"></th>
                <tbody>
                  <tr *ngFor="let stat of model.stats">
                    <td>{{stat.label}}</td>
                    <td>{{stat.cnt}}</td>
                  </tr>
                </tbody>
              </table>
            </ng-container>
          </div>
          <div *ngSwitchCase="UserRole.Agent">
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</p-dialog>
